<template>
  <iframe :class="$style.iframe" :src="info.iframeSrc" ref="iframe" scrolling="no" allowtransparency="true" frameborder="0"/>
</template>

<script>
export default {
  props: ['info', 'refObject'],
  methods: {
    onMessage(e) {
      const iframe = this.$refs.iframe;
      if (iframe.contentWindow !== e.source || (!(new RegExp(`^${e.origin}(/|$)`)).test(this.info.src) && e.origin !== location.origin)) return;

      const refObject = this.refObject;
      const param = e.data;
      switch (param.type) {
        case 'init':
          iframe.contentWindow.postMessage({
            type: 'init',
            value: this.info,
          }, '*');
          break;
        case 'onFullscreen':
          iframe.style.position = 'fixed';
          iframe.style.zIndex = 1000000;
          refObject.dispatch('fullscreenchange', true);
          break;
        case 'offFullscreen':
          iframe.style.position = 'absolute';
          iframe.style.zIndex = 0;
          refObject.dispatch('fullscreenchange', false);
          break;
        case 'onMounted':
          refObject.$iframeDidMount();
          break;
        case 'onPlay':
          refObject[param.value ? 'play' : 'pause']();
          break;
        case 'onReplay':
          refObject.$replay();
          break;
        case 'onMute':
          refObject.setMuted(param.value);
          break;
        case 'onRatechange':
          refObject.setPlaybackRate(param.value);
          break;
        case 'onSeek':
          refObject.seek(param.value);
          break;
        case 'onSwipe':
          refObject.dispatch('swipe', param.value);
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    window.addEventListener('message', this.onMessage, false);
    this.refObject.$setIframe(this.$refs.iframe);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onMessage, false);
  },
};
</script>

<style module>
.iframe {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// PlayerFrame.vue?6bc24df0